import React from "react";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { DataTable, SearchPropTypes } from "MODULES/shared/components";
import { shortDateYY } from "LIB/formatters/date";
import { getPartNumberColorClassNameByTierType } from "MODULES/shared/helpers";
import Stars from "MODULES/shared/components/Stars/Stars";
import { dollars } from "LIB/formatters/currency";
import PartNumber from "../../shared/components/PartNumber/PartNumber";

function renderRow(p, pushHistory) {
  const className = getPartNumberColorClassNameByTierType(p.tier_type_string);

  return (
    <tr
      key={p.id}
      className="clickable"
      onClick={() => pushHistory(`/parts/${p.id}`)}
    >
      <td>
        <PartNumber
          part={Object.assign(p, { tier_type: p.tier_type_string })}
          className={className}
          showIcon
        />
      </td>
      <td className="text-center">{shortDateYY(p.most_recent_sale_date)}</td>
      <td className="text-center">{dollars(p.most_recent_sale_price)}</td>
      <td className="text-center">{shortDateYY(p.most_recent_iq_date)}</td>
      <td className="text-center">{shortDateYY(p.most_recent_user_iq_date)}</td>
      <td>
        <Stars tierType={p.tier_type_string} />
      </td>
    </tr>
  );
}

export function Table({ results, pushHistory, isLoading }) {
  return (
    <DataTable loading={isLoading}>
      <DataTable.Head>
        <th>Part Number</th>
        <th className="text-center">Most Recent Sales Date</th>
        <th className="text-center">Most Recent Sales Price</th>
        <th className="text-center">Last Incoming Quote</th>
        <th className="text-center">Last Incoming Quote By Me</th>
        <th>Tier Type</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(r => renderRow(r, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/MyShoppingList/ResidentExpertSearch/Table.jsx